// Boletines sorted newest to oldest
import b_02_ago_2026 from '../files/boletines/Boletín_02 de agosto de 2026.pdf'
import b_21_jul_2026 from '../files/boletines/Boletín_21 de julio de 2026.pdf'
import b_02_jun_2026 from '../files/boletines/Boletín_02 de junio de 2026.pdf'
import b_28_may_2026 from '../files/boletines/Boletín_28 de mayo de 2026.pdf'
import b_18_may_2026 from '../files/boletines/Boletín_18 de mayo de 2026.pdf'
import b_01_may_2026 from '../files/boletines/Boletín_01 de mayo de 2026.pdf'
import b_29_abr_2026 from '../files/boletines/Boletín_29 de abril de 2026.pdf'
import b_08_mar_2026 from '../files/boletines/Boletín_08 de marzo de 2026.pdf'
import b_01_mar_2026 from '../files/boletines/Boletín_01 de marzo de 2026.pdf'
import b_23_feb_2026 from '../files/boletines/Boletín_23 de febrero de 2026.pdf'
import b_09_feb_2026 from '../files/boletines/Boletín_9 de febrero de 2026.pdf'
import b_17_dic_2025 from '../files/boletines/Boletín_17 de diciembre de 2025.pdf'
import b_27_nov_2025 from '../files/boletines/Boletín_27 de noviembre de 2025.pdf'
import b_16_oct_2025 from '../files/boletines/Boletín_16 de octubre de 2025.pdf'
import b_15_jul_2025 from '../files/boletines/Boletín_15 de julio de 2025.pdf'
import b_22_jun_2025 from '../files/boletines/Boletín_22 de junio de 2025.pdf'
import b_01_jun_2025 from '../files/boletines/Boletín_01 de junio de 2025.pdf'
import b_29_may_2025 from '../files/boletines/Boletín_29 de mayo de 2025.pdf'
import b_05_mar_2025 from '../files/boletines/Boletín_05 de marzo de 2025.pdf'
import b_13_dic_2024 from '../files/boletines/Boletín_13 de diciembre de 2024.pdf'
import b_16_may_2024 from '../files/boletines/Boletín_16 de mayo de 2024.pdf'
import b_06_may_2024 from '../files/boletines/Boletín_06 de mayo de 2024.pdf'
import b_01_may_2024 from '../files/boletines/Boletín_01 de mayo de 2024.pdf'
import b_29_mar_2024 from '../files/boletines/Boletín_29 de marzo de 2024.pdf'
import b_27_mar_2024 from '../files/boletines/Boletín_27 de marzo de 2024.pdf'

const boletines = [
  { year: 2026, label: '2 de agosto',    file: b_02_ago_2026 },
  { year: 2026, label: '21 de julio',    file: b_21_jul_2026 },
  { year: 2026, label: '2 de junio',     file: b_02_jun_2026 },
  { year: 2026, label: '28 de mayo',     file: b_28_may_2026 },
  { year: 2026, label: '18 de mayo',     file: b_18_may_2026 },
  { year: 2026, label: '1 de mayo',      file: b_01_may_2026 },
  { year: 2026, label: '29 de abril',    file: b_29_abr_2026 },
  { year: 2026, label: '8 de marzo',     file: b_08_mar_2026 },
  { year: 2026, label: '1 de marzo',     file: b_01_mar_2026 },
  { year: 2026, label: '23 de febrero',  file: b_23_feb_2026 },
  { year: 2026, label: '9 de febrero',   file: b_09_feb_2026 },
  { year: 2025, label: '17 de diciembre',file: b_17_dic_2025 },
  { year: 2025, label: '27 de noviembre',file: b_27_nov_2025 },
  { year: 2025, label: '16 de octubre',  file: b_16_oct_2025 },
  { year: 2025, label: '15 de julio',    file: b_15_jul_2025 },
  { year: 2025, label: '22 de junio',    file: b_22_jun_2025 },
  { year: 2025, label: '1 de junio',     file: b_01_jun_2025 },
  { year: 2025, label: '29 de mayo',     file: b_29_may_2025 },
  { year: 2025, label: '5 de marzo',     file: b_05_mar_2025 },
  { year: 2024, label: '13 de diciembre',file: b_13_dic_2024 },
  { year: 2024, label: '16 de mayo',     file: b_16_may_2024 },
  { year: 2024, label: '6 de mayo',      file: b_06_may_2024 },
  { year: 2024, label: '1 de mayo',      file: b_01_may_2024 },
  { year: 2024, label: '29 de marzo',    file: b_29_mar_2024 },
  { year: 2024, label: '27 de marzo',    file: b_27_mar_2024 },
]

export default boletines
